import React from 'react'
import './Footer.css';


export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <div className="wrapper">
            <div className="content">
                {/* Content space */}
            </div>
            <footer className="footer">
                <div className="footer-content centered">
                    <div className="copyright">
                        © {currentYear} Waghchaure Lawns. All rights reserved.
                    </div>
                </div>
            </footer>
        </div>
    )
}
